import React from "react";
import {
  Button,
  ButtonSize,
} from "@trussle/external-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import {
  GatsbyImage, ImageDataLike, getImage,
} from "gatsby-plugin-image";
import classNames from "classnames";
import { useReferrerFromCookie } from "../../helpers/landingParams";
import { IContentfulHeroProps } from "../../types/IHero";
import { trackEvent } from "../../helpers/analytics";
import "./styles.scss";
import { CTABanner } from "../CTABanner/CTABanner";
import { TrustpilotScore } from "../TrustpilotScore";
import { useHideImage } from "../../utils/useHideImage";

const Hero4: React.FC<IContentfulHeroProps> = ({
  heading1,
  heading2,
  disclaimerText,
  trustpilotIconLink,
  image,
}) => {
  const handleBuyClick = async () => {
    await trackEvent("Buy clicked", {
      module: "Hero4",
      element_type: "Button",
      section: "Megabutton",
    });
    // eslint-disable-next-line max-len
    window.location.assign(`${AUTH_UI_URL}/signup?application=eyJwcm9wZXJ0eURldGFpbHMiOnsib2ZmZXJBY2NlcHRlZCI6dHJ1ZX0sInB1cmNoYXNpbmdQdXJwb3NlIjoiUFVSQ0hBU0UiLCJwdXJjaGFzaW5nSW50ZW50Ijp7Im9mZmVyTWFkZSI6dHJ1ZSwib2ZmZXJTdGF0dXMiOiJBQ0NFUFRFRCJ9fQ==`);
  };

  const handleRemortgageClick = async () => {
    await trackEvent("Remortgage clicked", {
      module: "Hero4",
      element_type: "Button",
      section: "Megabutton",
    });
    window.location.assign("/get-started/remaining-term");
  };

  const handleGetStartedClick = async () => {
    await trackEvent("Get started clicked", {
      module: "Hero4",
      element_type: "Button",
      section: "CTA",
    });
    window.location.assign("/get-started");
  };
  const imageData = image ? useHideImage(getImage(image as ImageDataLike)!, "(max-width: 960px)") : null;
  const referred = useReferrerFromCookie();

  return (
    <div className="hero4">
      <div className="hero4__container_background">
        <div className={classNames("hero4__container", {
          hero4__container_partner: referred,
        })}
        >
          <div className="hero4__container__body">
            <div className="hero4__container__left">
              <section className="hero4__container__bodyText">
                {heading1 && (
                  <div className="hero4__heading">{renderRichText(heading1)}</div>
                )}
                {heading2 && (
                  <div className="hero4__subheading">
                    {renderRichText(heading2)}
                  </div>
                )}
              </section>
              <section className="hero4__container__bodyButtons">
                <Button
                  className="hero4__button"
                  testIds={{ button: "buy-button" }}
                  onClick={handleBuyClick}
                  size={ButtonSize.Large}
                >
                  Buy a new home
                </Button>
                <Button
                  className="hero4__button"
                  testIds={{ button: "remortgage-button" }}
                  onClick={handleRemortgageClick}
                  size={ButtonSize.Large}
                >
                  Remortgage
                </Button>
              </section>
            </div>
            <div className="optimizely__hero4__image">
              <div className="hero4__container__right">
                {image && (
                  <div className="hero4__image__container">
                    {image && <GatsbyImage image={imageData!} alt={image.title} />}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="hero4__footer">
            <div className="hero4__bits">
              <MaybeLink
                label="trustpilot"
                testId="hero-inlineimg1-link"
                url={trustpilotIconLink?.url}
              >
                <TrustpilotScore />
              </MaybeLink>
              {disclaimerText && (
                <div className="hero4__disclaimer">
                  {renderRichText(disclaimerText)}
                </div>
              )}
            </div>
          </div>
        </div>
        <CTABanner
          ctaLabel="Get started"
          onClick={handleGetStartedClick}
          text="Free mortgage advice that works for you"
        />
      </div>
    </div>
  );
};

type IMaybeLinkProps = {
  label: string;
  testId: string;
  children?: React.ReactNode;
  url?: string;
};

export function MaybeLink({
  label, testId, url, children,
}: IMaybeLinkProps) {
  if (url) {
    return (
      <a className={`hero4__${label}`} data-testid={testId} href={url}>
        {children}
      </a>
    );
  }
  return (
    <div className={`hero4__${label}`} data-testid={testId}>
      {children}
    </div>
  );
}
export default Hero4;
